import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { AttributeMetadata } from 'schemas/metadata/attributes.ts';

export interface AttributeMetadataResponse {
  META: {
    Timestamp: string;
  };
  AttributeRefData: AttributeMetadata[];
}

export default function useFetchAttributesMetadata() {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['metadata-attributes'],
    queryFn: () => apiFetch<AttributeMetadataResponse>({
      path: 'metadata/attributes',
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
  });
}
